import { Pipe, PipeTransform } from "@angular/core";
import { DataTableColumn } from "../data-table.type";

@Pipe({
  name: "linkBuilder",
})
export class LinkBuilderPipe<T> implements PipeTransform {
  transform(linkConfig: DataTableColumn<T>["link"], row: T): string {
    return linkConfig.path(row);
  }
}
